function cov_1m97lrkws5() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SinkVersionTwoFilled.tsx";
  var hash = "ac0442a29d7a979efbd4d63f983c8a276d87cead";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SinkVersionTwoFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 63
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ac0442a29d7a979efbd4d63f983c8a276d87cead"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1m97lrkws5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1m97lrkws5();
var Icon = (cov_1m97lrkws5().s[0]++, {
  name: 'sink-version-two-filled',
  svg: "<path d=\"M7.8734 18.1479C5.59428 15.8688 5.59428 12.1736 7.8734 9.89447L12.0001 5.76777L16.1268 9.89447C18.4059 12.1736 18.4059 15.8688 16.1268 18.1479C13.8477 20.427 10.1525 20.427 7.8734 18.1479Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\"2.5\"/>"
});
export default Icon;